<template>
  <div>
    <div v-if="selectedPlan">
      <v-layout wrap justify-center>
        <v-flex xs11 sm6 text-center>
          <v-card class="px-6 pt-8">
            <v-layout wrap>
              <v-flex text-end pr-4>
                <v-btn class="mt-6 secondary white--text" outlined v-if="selectedPlanIndex !== 0" @click="decreaseSelectedPlanIndex"><v-icon>mdi-minus</v-icon></v-btn>
                <div v-else style="width: 64px"></div>
              </v-flex>
              <v-flex text-center>  
                <h1 style="font-size:2.9em">
                  {{ selectedPlan.numberOfDossiersPerMonth == 10000 ? $t('unlimited') : selectedPlan.numberOfDossiersPerMonth }}
                </h1>
              </v-flex>
              <v-flex pl-4 text-left>
                <v-btn class="mt-6 secondary white--text" outlined v-if="selectedPlanIndex < plans.length - 1" @click="augmentSelectedPlanIndex"><v-icon>mdi-plus</v-icon></v-btn>
                <div v-else style="width: 64px"></div>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 text-center>
                <div>
                  {{ $t('c') }}
                </div>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <div v-if="isYearly" class="mt-6 mb-2">
                  <div class="text-center">
                    <span style="font-size: 3em" class="secondary--text"><b>{{ selectedPlan.amount }}</b></span>
                    <span class="ml-1">
                      <span>{{ $t('yYearly') }}</span>
                    </span>
                  </div>
                </div>
                <v-layout wrap v-if="isYearly && !isHidingYearlyDiscountText">
                  <!-- <v-flex xs6 text-end pr-2>
                    <div style="font-size: 1.4em; text-decoration: line-through" class="orange--text">{{ selectedPlan.amountBeforeYearlyDiscount }} {{ $t('yYearly') }}</div>
                  </v-flex> -->
                  <v-flex xs12 text-center>
                    <span style="font-size: 1.5em"><b>soit <span class="secondary--text">{{ Math.round(selectedPlan.amount/12) }}</span> €/mois</b></span>
                  </v-flex>
                  <v-flex xs12 text-center mb-4>
                    <v-chip color="orange" class="white--text pr-4" small>
                      <v-icon small class="mr-2">mdi-sale</v-icon>
                      {{ calculateDiscountInMonths(selectedPlan.amountBeforeYearlyDiscount, selectedPlan.amount) }}
                      {{ calculateDiscountInMonths(selectedPlan.amountBeforeYearlyDiscount, selectedPlan.amount) > 1 ? $t('freeMonths') : $t('freeMonth') }}
                    </v-chip>
                  </v-flex>
                </v-layout>
                <div v-else class="text-center mt-6">
                  <span style="font-size: 3em" class="secondary--text"><b>{{ selectedPlan.amount }}</b></span>
                  <span class="ml-2">
                    <span v-if="!isYearly">{{ $t('y') }}</span>
                  </span>
                </div>
              </v-flex>
            </v-layout>
            <v-layout wrap mt-4 :class="{ 'pb-4': !(!isYearlySwitchLocked && plansAreAvailableIfChangingIsYearlyValue) } ">
              <v-flex xs12 v-if="!isYearlySwitchLocked && plansAreAvailableIfChangingIsYearlyValue">
                <v-layout row wrap justify-center>
                  <v-flex xs1>
                    <v-switch
                      v-model="isYearly"
                      inset
                      color="secondary"
                      hide-details
                    />
                    <div style="position: relative; left: -220px; top: -25px; width: 200px" class="text-end" :class="{ 'secondary--text font-weight-bold': !isYearly }">
                      <span @click="isYearly = false" class="pointerWhenHover" :style="`font-size: ${!isYearly ? '0.85em' : '0.8em'};`">{{ $t('a') }}</span>
                    </div>
                    <div style="position: relative; right: -60px; top: -49px; width: 200px" class="text-left" :class="{ 'secondary--text font-weight-bold': isYearly }">
                      <span @click="isYearly = true" class="pointerWhenHover" :style="`font-size: ${isYearly ? '0.85em' : '0.8em'};`">{{ $t('b') }}</span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    initialIsYearly: {
      type: Boolean,
      default: null
    },
    isYearlySwitchLocked: {
      type: Boolean,
      default: false
    },
    strictlyMinimumNumberOfDossiersPerMonth: {
      type: Number,
      default: null
    },
    isHidingYearlyDiscountText: {
      type: Boolean,
      default: false
    },
    parentCompany: {
      type: Object,
      default: null
    },
    loadedPlans: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    selectedPlanIndex: 0,
    isYearly: true,
    monthlyPlans: [],
    yearlyPlans: [],
    hiddenMonthlyPlans: [],
    hiddenYearlyPlans: [],
  }),
  async mounted() {
    this.runInitWhenPlansAreLoaded()
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    company() {
      // Either user's company or its parentCompany
      if (this.user.company.parentCompanyId) {
        return this.parentCompany
      } else {
        return this.user.company
      }
    },
    plans() {
      return this.getPlans(this.isYearly)
    },
    pricingSelectorChoices() {
      return this.plans.map(plan => plan.numberOfDossiersPerMonth)
    },
    selectedPlan() {
      if (this.plans.length === 0) return null
      return this.plans[this.selectedPlanIndex]
    },
    plansAreAvailableIfChangingIsYearlyValue() {
      return this.getPlans(!this.isYearly).length > 0
    }
  },
  methods: {
    runInitWhenPlansAreLoaded() {
      if (this.loadedPlans) {
        this.runInit()
      } else {
        setTimeout(() => {
          this.runInitWhenPlansAreLoaded()
        }, 500)
      }
    },
    runInit() {
      if (this.initialIsYearly !== null) {
        this.isYearly = this.initialIsYearly
      }
      this.monthlyPlans = JSON.parse(JSON.stringify(this.loadedPlans.monthlyPlans));
      this.yearlyPlans = JSON.parse(JSON.stringify(this.loadedPlans.yearlyPlans));
      this.hiddenMonthlyPlans = JSON.parse(JSON.stringify(this.loadedPlans.hiddenMonthlyPlans));
      this.hiddenYearlyPlans = JSON.parse(JSON.stringify(this.loadedPlans.hiddenYearlyPlans));


      if (this.user.loggedIn) {
        if (this.company.onlyDisplayedPlanIds) {
          this.monthlyPlans = this.monthlyPlans.concat(this.hiddenMonthlyPlans).filter(plan => this.company.onlyDisplayedPlanIds.includes(plan.id))
          this.yearlyPlans = this.yearlyPlans.concat(this.hiddenYearlyPlans).filter(plan => this.company.onlyDisplayedPlanIds.includes(plan.id))
        } else if (this.company.additionallyDisplayedPlanIds) {
          for (let monthlyPlan of this.hiddenMonthlyPlans) {
            if (this.company.additionallyDisplayedPlanIds.includes(monthlyPlan.id)) {
              this.monthlyPlans.unshift(monthlyPlan)
            }
          }
          for (let yearlyPlan of this.hiddenYearlyPlans) {
            if (this.company.additionallyDisplayedPlanIds.includes(yearlyPlan.id)) {
              this.yearlyPlans.unshift(yearlyPlan)
            }
          }
        }

        if (this.getPlans(this.isYearly).length === 0 && !this.isYearlySwitchLocked) {
          this.isYearly = !this.isYearly
        }

        if (this.plans.find(plan => plan.numberOfDossiersPerMonth == 10000)) {
          this.selectedPlanIndex = this.plans.length - 1
        }
      }

      this.$emit('onSelectedPlanChange', this.selectedPlan)
    },
    getPlans(isYearly) {
      let plans = isYearly ? this.yearlyPlans : this.monthlyPlans
      if (this.strictlyMinimumNumberOfDossiersPerMonth) {
        plans = plans.filter(plan => plan.numberOfDossiersPerMonth > this.strictlyMinimumNumberOfDossiersPerMonth)
      }
      return plans.sort((a, b) => a.numberOfDossiersPerMonth - b.numberOfDossiersPerMonth)
    },
    augmentSelectedPlanIndex() {
      this.selectedPlanIndex += 1
    },
    decreaseSelectedPlanIndex() {
      this.selectedPlanIndex -= 1
    },
    calculateDiscountInMonths(amountBeforeDiscount, discountedAmount) {
      const monthlyPrice = amountBeforeDiscount / 12;
      const totalDiscount = amountBeforeDiscount - discountedAmount;
      const monthsOfDiscount = totalDiscount / monthlyPrice;
      return Math.round(monthsOfDiscount);
    }
  },
  watch: {
    isYearly: {
      handler() {
        if (this.selectedPlanIndex > this.plans.length - 1) this.selectedPlanIndex = this.plans.length - 1
      }
    },
    selectedPlan: {
      handler() {
        this.$emit('onSelectedPlanChange', this.selectedPlan)
      }
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "a": "Facturation mensuelle",
    "b": "Facturation annuelle",
    "c": "dossiers / mois",
    "x": "Le plus choisi",
    "y": "€/mois",
    "yYearly": "€/an",
    "freeMonth": "mois offert",
    "freeMonths": "mois offerts",
    "billedAnnually": "facturé à l'année",
    "unlimited": "illimité"
  },
  "en": {
    "a": "Billed monthly",
    "b": "Billed yearly",
    "c": "CVs / month",
    "d": "Billed yearly.",
    "d2": "If you wish to be billed monthly, contact us at martin@esnwebservices.com",
    "e": "Billed monthly.",
    "e2": "If you wish to be billed yearly, contact us at martin@esnwebservices.com",
    "x": "Most popular",
    "y": "€/month",
    "yYearly": "€/year",
    "freeMonth": "free month",
    "freeMonths": "free months",
    "billedAnnually": "billed annually",
    "unlimited": "unlimited"
  }
}
</i18n>


<style scoped>
  .v-slider__ticks{
    border-left: 0.5px solid !important;
    height: 10px;
    position: absolute;
    left: 50%;
    margin-left: -3px;
    top: -5px !important;
  }

  .pointerWhenHover:hover {
    cursor: pointer;
  }

</style>